import binarySearch from '../../binarySearch';

/**
 * @method getDocumentForPercentageOfBook
 */
const getDocumentForPercentageOfBook = (book, percentage) => {
  return binarySearch(book.documents, percentage, {
    isBeforeTarget: (document, comparisonValue) =>
      document?.percentageEnd < comparisonValue,
    isAfterTarget: (document, comparisonValue) =>
      comparisonValue < document?.percentageStart,
  });
};

export default getDocumentForPercentageOfBook;
